import { Injectable } from '@angular/core';
import { Content } from './admin/content.service';

/**
 * Centralized helper for classifying reports/content.
 * Currently provides logic to determine whether a report is considered a "Leaves" report.
 * Logic was previously embedded in components and is now reusable.
 */
@Injectable({ providedIn: 'root' })
export class ReportClassificationService {
  /**
   * Product IDs that were previously used to exclude Subscribe option
   * and indicate Leaves-related content.
   */
  private leavesRelatedProductIds = new Set<string>([
    'STD', 'LTD', 'FMLA', 'LOA', 'ADA', 'Benefit Calculations'
  ]);

  /**
   * Determine if a content item (report/dashboard/tile) is Leaves-related.
   * @param content Content item
   * @returns true if any productId matches a known Leaves-related id
   */
  public isLeavesReport(content: Pick<Content, 'productId'>): boolean {
    if (!content?.productId || content.productId.length === 0) return false;
    return content.productId.some(id => this.leavesRelatedProductIds.has(id));
  }

  /**
   * (Optional) Exposed list if other components need to inspect or extend it.
   */
  public getLeavesProductIds(): string[] {
    return Array.from(this.leavesRelatedProductIds);
  }
}
